import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelPhys.mjs'
import PhysStatus from './PhysStatus.mjs'

const PropertiesPanePhys = (props) => (
    <ProductPropertiesPane
        controllers={
            <>
                <Text prop="psName" />
                <LongText prop="psDesc" />
                <LongText prop="psMemo" />

                <Select
                    options={PhysStatus}
                    prop="psStatus"
                />

                <Text prop="psBu" />
                <Text prop="psDm" />
                <Text prop="psOm" />
                <Text prop="psEnv" />
                <Text prop="psHostname" />
                <Text prop="psIntranetIp" />
                <Text prop="psInternetIp" />
                <LongText prop="psOs" />
                <Text prop="psKernelVersion" />
                <LongText prop="psOpenPort" />
                <Text prop="psSerialNumber" />
                <LongText prop="psModel" />
                <Text prop="psCpu" />
                <Text prop="psMemory" />
                <Text prop="psHardDisk" />
                <Text prop="psMac" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPanePhys
